<button #openDrawerButton type="button" command="show-modal" commandfor="shopifyAffiliateDrawer"
  class="sr-only">Open drawer</button>

<el-dialog>
  <dialog #drawerDialog id="shopifyAffiliateDrawer" aria-labelledby="shopifyAffiliateDrawer-title"
    class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
    <el-dialog-backdrop (click)="closePanel()"
      class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
    </el-dialog-backdrop>
    <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
      (click)="$event.stopPropagation()">

      <el-dialog-panel
        class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
        (click)="$event.stopPropagation()">
        <div class="relative flex h-full flex-col overflow-hidden bg-white dark:bg-zinc-900 shadow-xl rounded-xl">

          @if (assignment(); as ctx) {
          <div class="shrink-0 border-b border-gray-200 dark:border-zinc-700 px-5 pt-5 pb-4">
            <div class="flex items-start justify-between gap-3">
              <div class="flex min-w-0 flex-1 items-start gap-3">
                <div
                  class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-zinc-900 text-white shout-plus-gold-shadow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5" aria-hidden="true">
                    <path d="m11 17 2 2a1 1 0 1 0 3-3" />
                    <path
                      d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
                    <path d="m21 3 1 11h-2" />
                    <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
                    <path d="M3 4h8" />
                  </svg>
                </div>
                <div class="min-w-0 pt-0.5">
                  <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                    {{ ctx.providerLabel || 'Shopify' }}</p>
                  <h2 id="shopifyAffiliateDrawer-title"
                    class="m-0 mt-0.5 text-lg font-bold leading-tight text-gray-900 dark:text-zinc-100">Affiliate
                    assignment</h2>
                </div>
              </div>
              <button type="button"
                class="btn-fab-secondary text-secondary"
                (click)="closePanel()" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </button>
            </div>
          </div>

          <div class="flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden px-5 py-4 scrollbar-transparent">
            <div class="mb-4 flex flex-wrap items-center justify-between gap-2">
              <span class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-semibold"
                [class]="isAssignmentExpired(ctx)
                  ? 'bg-red-50 text-red-800 dark:bg-red-900/30 dark:text-red-300'
                  : 'bg-emerald-50 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300'">
                <span class="h-1.5 w-1.5 shrink-0 rounded-full"
                  [class]="isAssignmentExpired(ctx) ? 'bg-red-500' : 'bg-emerald-600'"></span>
                {{ isAssignmentExpired(ctx) ? 'Expired' : 'Active' }}
              </span>
              @if (ctx.briefTitle) {
              <span
                class="max-w-[55%] truncate rounded-full bg-gray-100 dark:bg-zinc-800 px-3 py-1 text-sm font-medium text-gray-700 dark:text-zinc-300">
                {{ ctx.briefTitle }}
              </span>
              }
            </div>

            <div class="mb-5 flex overflow-hidden rounded-xl bg-zinc-900 text-white shout-plus-gold-shadow">
              <div class="flex min-w-0 flex-1 flex-col gap-1 px-4 py-4">
                <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-white/80">Est. commission</p>
                <p class="m-0 truncate text-2xl font-bold leading-tight">
                  {{ ((ctx.commissionValue ?? 0) / 100) | currency: currencyForDisplay(ctx) :
                  'symbol-narrow' : '1.2-2' }}
                </p>
              </div>
              <div class="w-px shrink-0 self-stretch bg-white/25 my-3"></div>
              <div class="flex min-w-0 flex-1 flex-col gap-1 px-4 py-4 text-right">
                <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-white/80">Rate</p>
                <p class="m-0 text-2xl font-bold leading-tight">{{ displayCommission(ctx) }}</p>
              </div>
            </div>

            <div class="mb-4 flex flex-col gap-1.5">
              <h3 class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                Affiliate link</h3>
              @if (ctx.trackingUrl; as trackingUrl) {
              <div class="flex items-center gap-2 rounded-lg bg-stone-100 dark:bg-zinc-800 px-2.5 py-2">
                <span class="min-w-0 flex-1 truncate text-sm font-medium text-gray-800 dark:text-zinc-200"
                  [title]="trackingUrl">
                  {{ trackingUrl | truncate: 38 }}
                </span>
                <div class="flex shrink-0 items-center gap-1.5">
                  <button type="button"
                    class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-900 text-gray-600 dark:text-zinc-400 hover:bg-gray-50 dark:hover:bg-zinc-800/80"
                    (click)="copyItem(trackingUrl, 'affiliate link')" appTooltip="Copy affiliate link" position="bottom"
                    aria-label="Copy affiliate link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="size-4">
                      <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                    </svg>
                  </button>
                  <a [href]="trackingUrl" target="_blank" rel="noopener noreferrer"
                    class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-900 text-gray-600 dark:text-zinc-400 hover:bg-gray-50 dark:hover:bg-zinc-800/80"
                    appTooltip="Open link" position="bottom" aria-label="Open affiliate link in new tab">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="size-4">
                      <path d="M15 3h6v6" />
                      <path d="M10 14 21 3" />
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    </svg>
                  </a>
                </div>
              </div>
              } @else {
              <p class="m-0 rounded-lg bg-stone-100 dark:bg-zinc-800 px-2.5 py-2 text-sm text-gray-400">N/A</p>
              }
            </div>

            @if (ctx.discountCode) {
            <div class="mb-4 flex flex-col gap-1.5">
              <h3 class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                Discount code</h3>
              <div class="flex items-stretch gap-2">
                <div
                  class="flex min-h-10 min-w-0 flex-1 items-center rounded-lg bg-stone-100 dark:bg-zinc-800 px-3 py-2 font-mono text-sm font-semibold text-gray-900 dark:text-zinc-100">
                  {{ ctx.discountCode }}
                </div>
                <button type="button"
                  class="inline-flex w-10 shrink-0 items-center justify-center self-stretch rounded-lg border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-900 text-gray-600 dark:text-zinc-400 hover:bg-gray-50 dark:hover:bg-zinc-800/80"
                  (click)="copyItem(ctx.discountCode, 'discount code')" appTooltip="Copy discount code"
                  position="bottom" aria-label="Copy discount code">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                    <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                  </svg>
                </button>
              </div>
            </div>
            }

            <div class="mb-5 flex flex-col gap-2">
              <h3 class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                Validity window</h3>
              <div class="flex items-start justify-between gap-4">
                <div class="min-w-0 flex-1">
                  <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                    Created</p>
                  <p class="m-0 mt-0.5 text-sm font-medium text-gray-900 dark:text-zinc-100">
                    {{ ctx.createdDate ? (ctx.createdDate | date: 'dd MMM yyyy') : '—' }}
                  </p>
                </div>
                <div class="min-w-0 flex-1 text-right">
                  <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                    Expiry</p>
                  <p class="m-0 mt-0.5 text-sm font-medium text-gray-900 dark:text-zinc-100">
                    {{ ctx.expiresAt ? (ctx.expiresAt | date: 'dd MMM yyyy') : '—' }}
                  </p>
                </div>
              </div>
              <div class="h-2 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-zinc-700">
                <div class="h-full rounded-full shout-plus-gold-ring transition-all duration-300"
                  [style.width.%]="miscService.getExpiryTimeLeftPercent(ctx.createdDate, ctx.expiresAt, countdownNowMs) ?? 0">
                </div>
              </div>
              <div class="flex items-center justify-between gap-2 text-[11px] text-gray-500 dark:text-zinc-400">
                <span>{{ formatTimeLeftLabel(ctx.expiresAt) }}</span>
                <span>{{ (miscService.getExpiryTimeLeftPercent(ctx.createdDate, ctx.expiresAt,
                  countdownNowMs) ?? 0) | number:'1.0-0' }}%</span>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <h3 class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                Metrics</h3>
              <div class="grid grid-cols-3 gap-2">
                <div class="rounded-lg bg-stone-100 dark:bg-zinc-800 px-2 py-3 text-center">
                  <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                    Clicks</p>
                  <p class="m-0 mt-1 text-lg font-bold text-gray-900 dark:text-zinc-100">{{ ctx.clicks || 0 }}
                  </p>
                </div>
                <div class="rounded-lg bg-stone-100 dark:bg-zinc-800 px-2 py-3 text-center">
                  <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                    {{ ctx.providerLabel === 'Rakuten' ? 'Orders' : 'Used' }}</p>
                  <p class="m-0 mt-1 text-lg font-bold text-gray-900 dark:text-zinc-100">{{ ctx.timesUsed || 0
                    }}</p>
                </div>
                <div class="rounded-lg bg-stone-100 dark:bg-zinc-800 px-2 py-3 text-center">
                  <p class="m-0 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                    Revenue</p>
                  <p class="m-0 mt-1 truncate text-lg font-bold"
                    [class]="(ctx.revenue || 0) > 0 ? 'text-emerald-600' : 'text-gray-400'">
                    {{ ((ctx.revenue ?? 0) / 100) | currency: currencyForDisplay(ctx) : 'symbol-narrow' :
                    '1.0-0' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          } @else {
          <div class="flex flex-1 items-center justify-center px-5 py-10 text-center">
            <p class="m-0 text-sm text-gray-500 dark:text-zinc-400">
              No assignment details available. Close and try again.
            </p>
          </div>
          }

        </div>
      </el-dialog-panel>
    </div>
  </dialog>
</el-dialog>
